<template>
   <landing-page />
</template>

<script>
import LandingPage from './components/LandingPage.vue';

export default {
   name: 'App',
   components: {
      LandingPage,
   },
   beforeMount() {
      window.addEventListener('consent-changed', (e) => {
         this.$store.commit('setAllowedCookieCategories', e.detail);
      });
   },
   mounted() {
      const query = new URLSearchParams(document.location.search);
      window.app = this;
      console.log('mounted', this);
      if (query.has('test-overflow')) {
         if (query.has('width')) {
            // window.resizeTo(query.get('width'), window.innerHeight);
            setTimeout(() => {
               this.detectHorizontalOverflow(true);
            }, 100);
         }
      }
   },
   methods: {
      t() {
         let offset = 0;
         for (const width of [1026, 927, 450]) {
            window.open(
               'http://landingpage.test?test-overflow&width=' + width,
               '_' + width,
               `width=${width},height=${window.innerHeight},left=${offset},top=0`
            );
            offset += width + 50;
         }
      },
      shrinkTest() {
         window.runTest = true;
         window.oStart = null;
         window.oelm = null;
         window.testSize = (w, h) => {
            w = w || window.outerWidth;
            h = h || window.innerHeight;
            if (!window.runTest || w <= 200) {
               return;
            }
            w--;
            window.resizeTo(w, h);
            setTimeout(() => {
               const o = window.app.detectHorizontalOverflow();
               if (o.length && !window.oStart) {
                  window.oStart = w;
                  window.oelm = o;
               }
               if (window.oStart && !o.length) {
                  console.log('Overflow from %d to %d', w, window.oStart, window.oelm);
                  window.oStart = null;
                  window.oelm = null;
               }
               if (w > 200) {
                  window.testSize(w, h);
               } else {
                  if (window.oStart) {
                     console.log('Overflow from %d to %d', w, window.oStart, window.oelm);
                     window.oStart = null;
                  }
               }
            }, 50);
         };
      },
      detectHorizontalOverflow(print) {
         // 1005 - 1027: Product btns
         // 781 - 928: Testimonial
         // 200 - 451: Testimonial
         const { offsetWidth } = document.documentElement;
         let previousOverflowing = null;
         let overflowing = [];
         document.querySelectorAll('*').forEach((el) => {
            const { right } = el.getBoundingClientRect();
            if (right > offsetWidth) {
               // Ignore the children of overflowing elements. The issue is probably their parents.
               if (previousOverflowing === null || !previousOverflowing.contains(el)) {
                  if (print) {
                     console.log('Right edge at %dpx, overflowing %dpx', right, right - offsetWidth, el);
                  }
                  el.style.opacity = '1';
                  el.style.visibility = 'visible';
                  el.style.backGroundColor = 'rgba(255,0,0,.3)';
                  el.style.outline = '1px solid #f00';
                  previousOverflowing = el;
                  overflowing.push(el);
               }
            }
         });
         return overflowing;
      },
   },
};
</script>
